_ = require('lodash')
moment = require('moment')
$ = require('jquery')

GroupEventSubmitScoreCtrl = ($scope ,$translate ,$filter ,flash , $location ,groupEventService ,detailData ,$ngConfirm, $modal, ScoreCardAPIService) ->
  angular.element(document.body).css 'min-width', 0
  pageSize = 4
  maxSelectScore = 15
  $scope.lstScoreCards = []
  $scope.lstUploadScore = []
  $scope.currentPage = 0
  $scope.isLoading = false
  $scope.noResults = true
  $scope.isSubmitScore = false
  $scope.eventDetail = detailData.eventDetail
  $scope.groupDetail = detailData.groupDetail
  $scope.isFilterOpen = false
  $scope.filterPeriodItem = "all"
  $scope.filterSelectedPeriod = $filter('translate')('_GROUP_EVENT.FILTER_PERIOD_ALL')
  $scope.filterStatusItem = "all"
  $scope.filterSelectedStatus = $filter('translate')('_GROUP_EVENT.FILTER_STATUS_ALL')
  $scope.filterCourseList = [
    { id: 0, name: $filter('translate')('_GROUP_EVENT.FILTER_COURSE_ALL'), checked: true }
  ]
  $scope.filterSelectedCourse = $filter('translate')('_GROUP_EVENT.FILTER_COURSE_ALL')
  $scope.filterSelectedCourseResult = $filter('translate')('_GROUP_EVENT.FILTER_COURSE_ALL')
  $scope.filterSelectedCourseList = []
  $scope.pcFilterText = $filter('translate')('_GROUP_EVENT.FILTER_PC')
  $scope.spFilterText = $filter('translate')('_GROUP_EVENT.FILTER')
  $scope.closeText = $filter('translate')('_GROUP_EVENT.FILTER_CLOSE')

  $(document).ready(() ->
    item = $('.row.buttonRegion')[0]
    curOffset = item.offsetTop
    window.onscroll = ->
      if window.innerWidth > 768
        return
        # body...
      if window.pageYOffset >= curOffset
        item.classList.add("sticky")
      else
        item.classList.remove("sticky")
  )

  angular.element(window).bind('resize', ->
    if window.innerWidth > 768
      $('.row.buttonRegion').first().removeClass('sticky')
  )

  buildCoursesParam = () ->
    if 0 in $scope.filterSelectedCourseList
      []
    else
      $scope.filterSelectedCourseList

  buildStatusParam = () ->
    switch $scope.filterStatusItem
      when "submitted"
        "true"
      when "unsubmit"
        "false"
      else
        ""
  $scope.loadModalCourses = ->
    if $scope.filterCourseList.length <= 1
      params =
        id : $scope.eventDetail.id

      groupEventService.getCourses(params)
        .then (data) ->
          buildCourseList(data.courses)

  buildCourseList = (courses) ->
    for course in courses
      $scope.filterCourseList.push({ id: course.id, name: course.name, checked: false })

  $scope.loadMore = ->
    $scope.isLoading = true
    $scope.currentPage++
    params =
      id : $scope.eventDetail.id
      page : $scope.currentPage
      page_size : pageSize
      period : $scope.filterPeriodItem
      submitted : buildStatusParam()
      'courses[]' : buildCoursesParam()
    groupEventService.listScoreCardByEvent(params)
      .then (data) ->
        $scope.lstScoreCards = _.union($scope.lstScoreCards , data.score_cards)
        $scope.totalPages = data.total_pages
        $scope.noResults = $scope.lstScoreCards.length is 0
      .finally ->
        $scope.isLoading = false

  $scope.hasMore = ->
    $scope.noResults == false && $scope.currentPage isnt $scope.totalPages

  $scope.displayPeriod = (startTime, endTime) ->
    reText = ""
    if !startTime && !endTime
      return reText
    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME')
    reText += ": "
    reText += $scope.displayDateByLang(startTime)
    reText += "~"
    reText += $scope.displayDateByLang(endTime)
    reText

  $scope.displayDateByLang = (time) ->
    if !time
      return ""
    d = moment(time)
    formatText = 'YYYY-MM-DD(ddd)'
    if /^ja/i.test $translate.preferredLanguage()
      formatText = 'LL(ddd)'
      moment.locale('ja')
    d.format(formatText)

  $scope.$watch('lstScoreCards' , (newVal , oldVal) ->
    $scope.checkSelectedScore()
  , true)

  $scope.clickSubmit = (scoreCard) ->
    if !scoreCard.selected  && $scope.lstUploadScore.length >= maxSelectScore
      $ngConfirm('Limits score card uploads is 15')
      return
    scoreCard.selected = !scoreCard.selected

  $scope.checkSelectedScore = ->
    $scope.lstUploadScore = $filter('filter')($scope.lstScoreCards, {selected: true})
    $scope.canUpload =  $scope.lstUploadScore.length > 0

  $scope.submitScore = ->
    if !$scope.canUpload
      return
    $scope.isSubmitScore = true
    params =
      group_event_id: $scope.eventDetail.id
      score_card_ids: $scope.lstUploadScore.map((item) -> item.id)
    groupEventService.submitScoreCard(params).then (resp) ->
      $location.path('/group-event/'+ $scope.eventDetail.id + '/ranking')
    .catch (resp) ->
      if resp.data?.code == 'error.group_event_not_active'
        flash.error 'Event is not active'
      else
        flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isSubmitScore = false
      ScoreCardAPIService.clearAllMembersByEventData($scope.eventDetail.id)

  $scope.btnCancelClick = ->
    $location.path('/group-event/'+ $scope.eventDetail.id + '/ranking')

  $scope.btnOpenMenuClick = ->
    $scope.isFilterOpen = !$scope.isFilterOpen
    $scope.currentYear = new Date().getFullYear()

  $scope.btnOpenModal = ->
    modalInstance = $modal.open({
      templateUrl: 'course-modal',
      controller: 'CourseListModalCtrl',
      scope: $scope
    })
    modalInstance.result.then (result) ->
      checkedList = []
      checkedIdList = []
      for course in result
        if course.checked
          checkedList.push(course.name)
          checkedIdList.push(course.id)
      $scope.filterSelectedCourseList = checkedIdList
      $scope.filterSelectedCourse = getSelectedValue(checkedList)

  $scope.btnFilterClick = ->
    $scope.isLoading = true
    $scope.currentPage = 1
    params =
      id : $scope.eventDetail.id
      page : $scope.currentPage
      page_size : pageSize
      period : $scope.filterPeriodItem
      submitted : buildStatusParam()
      'courses[]' : buildCoursesParam()

    groupEventService.listScoreCardByEvent(params)
      .then (data) ->
        $scope.lstScoreCards = data.score_cards
        $scope.totalPages = data.total_pages
        $scope.noResults = $scope.lstScoreCards.length is 0
        changeFilterValues()
      .finally ->
        $scope.isLoading = false
        $scope.isFilterOpen = false

  $scope.loadMore()
  $scope.loadModalCourses()

  $scope.onDeleteClick = (scoreCard) ->
    params =
      score_card_id : scoreCard.id
      group_event_id : $scope.eventDetail.id

    mess = $filter('translate')('_GROUP_EVENT.CONFIRM_MESS')
    errorMess = $filter('translate')('_GROUP_EVENT.CANCEL')
    config =
      title: ''
      content: mess
      buttons:
        Cancel:
          text: $filter('translate')('_GROUP_EVENT.CANCEL')
        OkButton:
          text: 'OK'
          action: ->
            groupEventService.unSubmitScoreCard(params)
              .then (resp) ->
                refreshListData()
                ScoreCardAPIService.clearAllMembersByEventData($scope.eventDetail.id)
              .catch (resp) ->

    $ngConfirm(config)

  refreshListData = ->
    $scope.lstScoreCards = []
    $scope.currentPage = 0
    $scope.isLoading = false
    $scope.noResults = true
    $scope.loadMore()

  $scope.$watch('lstScoreCards' , () ->
    if $scope.currentPage <= 1
      return
    $("html, body").animate({ scrollTop:$(document).height()}, "slow")
  , false)

  $scope.periodChange = (value) ->
    $scope.filterPeriodItem = value

  $scope.statusChange = (value) ->
    $scope.filterStatusItem = value

  changeFilterValues = () ->
    $scope.filterSelectedPeriod = getPeriodValue()
    $scope.filterSelectedStatus = getStatusValue()
    $scope.filterSelectedCourseResult = $scope.filterSelectedCourse

  getPeriodValue = () ->
    switch $scope.filterPeriodItem
      when "all"
        $filter('translate')('_GROUP_EVENT.FILTER_PERIOD_ALL')
      when "year"
        "2018"
      when "twoYears"
        "2017"
      when "threeMonth"
        $filter('translate')('_GROUP_EVENT.FILTER_PERIOD_THREE_MONTH')
      else
        $filter('translate')('_GROUP_EVENT.FILTER_PERIOD_SIX_MONTH')

  getStatusValue = () ->
    switch $scope.filterStatusItem
      when "all"
        $filter('translate')('_GROUP_EVENT.FILTER_STATUS_ALL')
      when "unsubmit"
        $filter('translate')('_GROUP_EVENT.FILTER_STATUS_NOTYET')
      else
        $filter('translate')('_GROUP_EVENT.FILTER_STATUS_DONE')

  getSelectedValue = (checkedList) ->
    allCourse = $filter('translate')('_GROUP_EVENT.FILTER_COURSE_ALL')
    if checkedList.length <= 0 || allCourse in checkedList
      allCourse
    else if checkedList.length >= 2 && !(allCourse in checkedList)
      checkedList[0] + " 他"
    else
      checkedList[0]

  $scope.classForRoundIcons = (scoreCard) ->
    switch scoreCard.round_type
      when 1.5 then 'icons-extra9'
      when 0.5 then 'icons-half-nine'
      else ''

GroupEventSubmitScoreCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  'flash'
  '$location'
  'groupEventService'
  'detailData'
  '$ngConfirm'
  '$modal'
  'ScoreCardAPIService'
]

module.exports = GroupEventSubmitScoreCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/group-event-submit-score-controller.coffee